import { createContext } from 'react';

export interface TeamsClientOptions {
  readonly collapseContentSidebar: boolean;
  readonly shouldHideHeaders: boolean;
  readonly shouldHideLeftSidebar: boolean;
  readonly shouldHideSubHeader: boolean;
  readonly shouldShowStaticAppHeader: boolean;
}

export const defaultOptions: TeamsClientOptions = {
  collapseContentSidebar: false,
  shouldHideHeaders: false,
  shouldHideLeftSidebar: false,
  shouldHideSubHeader: false,
  shouldShowStaticAppHeader: false,
};

export const TeamsClientContext = createContext(defaultOptions);
